import { gql } from "@apollo/client";

export const GET_SETTINGS = gql`
  query GetSettings($input: SettingsInput!) {
    settings(input: $input) {
      total
      settings {
        id
        schemaType
        authorId
        domain
        type
        data
        createdAt
        updatedAt
      }
    }
  }
`;
